// extracted by mini-css-extract-plugin
export default {"organisation_business_unit_select":"BUWithLocationsSelect_organisation_business_unit_select__-w4Ao","spin":"BUWithLocationsSelect_spin__NDUWI"};